"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinchScopeTypeSchema = exports.FinchScopeType = void 0;
const zod_1 = __importDefault(require("zod"));
var FinchScopeType;
(function (FinchScopeType) {
    FinchScopeType["HR_ONLY"] = "HR_ONLY";
    FinchScopeType["FULL_PAYROLL"] = "FULL_PAYROLL";
})(FinchScopeType || (exports.FinchScopeType = FinchScopeType = {}));
exports.FinchScopeTypeSchema = zod_1.default.enum([FinchScopeType.HR_ONLY, FinchScopeType.FULL_PAYROLL]);
